import { render, staticRenderFns } from "./ChannelsTable.vue?vue&type=template&id=4bd70496&scoped=true"
import script from "./ChannelsTable.vue?vue&type=script&lang=js"
export * from "./ChannelsTable.vue?vue&type=script&lang=js"
import style0 from "./ChannelsTable.vue?vue&type=style&index=0&id=4bd70496&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd70496",
  null
  
)

export default component.exports